import React from 'react';

const Footer = () => (

    <div className="footer-txt">
        {process.env.REACT_APP_Var_FOR_Powered_by}
        <br />
        {process.env.REACT_APP_Var_FOR_Copyright_All_rights_Reserved}
    </div>

)
export default Footer;
